"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaCliente = exports.yupCliente = void 0;
const yup = __importStar(require("yup"));
//import { ILogCatraca } from '.';
const enums_1 = require("../enums");
const utils_1 = require("../utils");
const estado_1 = require("./estado");
exports.yupCliente = yup.object({
    tipoPessoa: yup
        .mixed()
        .oneOf(Object.values(enums_1.EClienteTipoPessoa))
        .required()
        .default(enums_1.EClienteTipoPessoa.Fisica)
        .label('Tipo de Pessoa'),
    nome: yup.string().default('').max(65).required().label('Nome'),
    profissao: yup.string().default('').max(150).label('Profissão'),
    trabalho: yup.string().default('').max(150).label('Local de Trabalho'),
    naoCobrar: yup.boolean().required().default(false).label('Não Enviar Cobranca'),
    email: yup.string().default('').email().max(60).required().label('Email'),
    funcionario: yup.boolean().required().default(false).label('Funcionário da Instituição'),
    login: yup.string().default('').max(20).notRequired().label('Login'),
    senha: yup.string().max(15).notRequired().label('Senha'),
    cpf: yup.string().default('').max(15).label('Cpf'),
    rg: yup.string().default('').max(15).label('Rg'),
    dataNascimento: (0, utils_1.sge2Date)().default(null).nullable().label('Data Nascimento'),
    rgEstado: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default('')
        .label('Estado Rg'),
    estadoCivil: yup.mixed().oneOf(Object.keys(enums_1.EEstadoCivil)).default('Não Informado').label('Estado Civil'),
    endereco: yup.string().default('').max(55).label('Endereço'),
    numero: yup.string().default('').max(5).label('Número'),
    bairro: yup.string().default('').max(150, 'Máximo de 150 caracteres.').label('Bairro'),
    estado: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla).concat(['']))
        .default('')
        .label('Estado'),
    cidade: yup.string().default('').max(30).label('Cidade'),
    cep: yup.string().default('').max(10).label('Cep'),
    telefone: yup.string().default('').max(15).label('Telefone'),
    celular: yup.string().default('').max(15).label('Celular'),
    nomePai: yup.string().default('').max(65).label('Nome do Pai'),
    nomeMae: yup.string().default('').max(65).label('Nome da Mãe'),
    instrucao: yup.string().default('').max(2).label('Nível de Instrução'),
    religiao: yup.string().default('').max(40).label('Religião'),
    apartamento: yup.string().default('').max(5).label('Apartamento'),
    categoria: yup.string().default('').max(1).label('Categoria'),
    bloco: yup.string().default('').max(15).label('Bloco'),
    naturalidade: yup.string().default('').max(40).label('Naturalidade'),
    estadoNaturalidade: yup
        .string()
        .oneOf(estado_1.estado.map((m) => m.sigla))
        .default('')
        .label('Estado Naturalidade'),
    nacionalidade: yup.string().default('').max(40).label('Nacionalidade'),
    razao: yup.string().default('').max(65).label('Razão Social'),
    inscricaoEstadual: yup.string().default('').max(15).label('inscrição Estadual'),
    cnpj: yup.string().default('').max(15).label('Cnpj'),
    inscricaoMunicipal: yup.string().default('').max(10).label('Inscrição Municipal'),
    idImagem: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .integer()
        .default(null)
        .nullable()
        .label('Imagem Cliente'),
});
exports.schemaCliente = exports.yupCliente.shape({});
